import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import '../scss/tabs-change.scss';

interface IProps {
  onChange: (code: number) => void
  code: number
}
interface IState { }

const timeData = [{
  value: '春节',
  code: 0,
}, {
  value: '端午',
  code: 1,
}, {
  value: '中秋',
  code: 2,
}];

const HolidayChange = (props: IProps, state: IState) => {
  const { onChange, code } = props;
  const [active, setActive] = useState<number>(0);
  useEffect(() => {
    setActive(code);
    return () => { };
  }, [code]);
  const action = (code: number) => {
    setActive(code);
    onChange(code);
  };
  return (
    <section className="welfare-tab-content-01">
      {timeData?.map(item => (
        <p
          aria-hidden="true"
          key={item.code}
          className={item.code === active ? 'tab-item-active' : 'tab-item'}
          onClick={() => action(item.code)}>
          {item.value}
        </p>
      ))}
    </section>
  );
};

export default observer(HolidayChange);
